import { compactSpaces } from '../../../../utils/helpers/string.helper';
import { LocationSuggestionResult } from '../../../geolocation-data/models/location-suggestion-result.model';

export const locationSuggestionTmpl = (
  liDom: any,
  locationSuggestionResult: LocationSuggestionResult
) => {
  const address = `
    <div class="result-address">
      ${locationSuggestionResult.text.replace(/[\n\r]+/g, '<br>')}
    </div>
  `;
  // const distance = locationSuggestionResult.distance ?
  //   `
  //     <div class="result-distance">
  //       ${ locationSuggestionResult.distance }
  //     </div>
  //   ` :
  //   '';
  const contents = `
    <div class="location-suggestion">
      ${address}  
    </div>
  `;

  liDom.innerHTML = compactSpaces(contents);
};

export const categoryTmpl = (
  label: string,
  categoryDom: any,
  query: string
) => {
  const contents = query
    ? ''
    : `
      <div class="category-header">
        <span class="category-label">
          ${label}
        </span>
      
        <hr class="category-divider" />
      </div>  
    `;

  categoryDom.innerHTML = compactSpaces(contents);
};
